module.exports = __webpack_public_path__ + "img/tweet-delete.33b03ef3.svg";